var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Lineal__Icn/40px/Lineal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Lineal__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Lineal__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.0689655,15 C31.5831617,15 32,15.4477153 32,16 L32,24 C32,24.5522847 31.5831617,25 31.0689655,25 L8.93103448,25 C8.41683834,25 8,24.5522847 8,24 L8,16 C8,15.4477153 8.41683834,15 8.93103448,15 L31.0689655,15 Z M13,17 L10,17 L10,23 L30,23 L30,17 L27,17 L27,20 L25,20 L25,17 L21,17 L21,21 L19,21 L19,17 L15,17 L15,20 L13,20 L13,17 Z",
    id: ".._.._src_svg_Icn_40px_Lineal__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineal);
export default __webpack_public_path__ + "static/media/Lineal.ffa6922611f9bb28f7f978e6849f69f0.svg";
export { ForwardRef as ReactComponent };